import React, { useEffect, useState, useRef } from 'react'
import { FaFacebookF, FaInstagram, FaLinkedin, FaTwitter, FaGithubSquare, FaCamera, FaSignOutAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom';
// Bootstrap If Required
import firebase from '../../firestore'
import { ProgressBar } from 'react-bootstrap'
import User from '../../assets/User.jpg'
const ImagePanel = (props) => {
    const userImageFile = useRef()
    const [uploading, setUploading] = useState(false)

    let userDetails = props.userDetails
    let image = props.userDetails.image
    return (
        <div className="ImagePanel_Dashboard">
            <div className="imgContainerDash">
                {uploading ? (
                    <div style={{ height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <ProgressBar animated variant="success" now={uploading} />
                    </div>
                ) :
                    <React.Fragment>
                        <img src={image ? image : User} />
                        <div className="imageOverlay">
                            <span className="camera-icon">
                                <input
                                    onChange={(e) => {
                                        const file = e.target.files[0]
                                        console.log(file)
                                        var imageReg = /[\/.](gif|jpg|jpeg|tiff|png)$/i;
                                        if (!file.name || !file) {
                                            return
                                        }
                                        if (!file.name.match(imageReg)) {
                                            console.error(`not an image, the image file is a ${typeof (file)}`)
                                            return
                                        }
                                        const uploadTask = firebase.storage().ref(`/profileImages/${userDetails.username}`).put(file)
                                        uploadTask.on('state_changed',
                                            (snapShot) => {
                                                console.log(snapShot)
                                                setUploading(snapShot.bytesTransferred / snapShot.totalBytes * 100)
                                            }, (err) => {
                                                console.log(err)
                                            }, () => {
                                                firebase.storage().ref('profileImages').child(userDetails.username).getDownloadURL()
                                                    .then(fireBaseUrl => {
                                                        firebase.database().ref('/users/' + userDetails.username + '/image/')
                                                            .set(fireBaseUrl)

                                                    }).then(() => { setUploading(false) })
                                            })

                                    }}
                                    ref={userImageFile}
                                    type="file" name="uploadfile" id="img" style={{ display: "none" }} accept="image/*" />
                                <label for="img"><FaCamera /></label>
                            </span>
                        </div>
                    </React.Fragment>}


            </div>


            <div className="SocialMedia">
                {userDetails.facebook ?
                    <a href={userDetails.facebook}>
                        <FaFacebookF className="icons" target="_blank" rel="noreferrer noopener" />
                    </a>
                    : null}
                {userDetails.instagram ?
                    <a href={userDetails.instagram}>
                        <FaInstagram className="icons" target="_blank" rel="noreferrer noopener" />
                    </a>
                    : null}
                {userDetails.linkedin ?
                    <a href={userDetails.linkedin}>
                        <FaLinkedin className="icons" target="_blank" rel="noreferrer noopener" />
                    </a>
                    : null}
                {userDetails.twitter ?
                    <a href={userDetails.twitter}>
                        <FaTwitter className="icons" target="_blank" rel="noreferrer noopener" />
                    </a>
                    : null}
                {userDetails.github ?
                    <a href={userDetails.github}>
                        <FaGithubSquare className="icons" target="_blank" rel="noreferrer noopener" />
                    </a>
                    : null}
            </div>

            <div className="ButtonsNavigation">
                <Link to="/detailForm" className="btn btn-lg btn-primary editBTN" >Edit your details?</Link>
            </div>
            <div className="ButtonsNavigation">
                <div onClick={() => { window.location = "/" + userDetails.username }} className="btn btn-lg btn-primary siteBTN" >Have a look at your Page</div>
            </div>
            <div className="ButtonsNavigation">
                <button onClick={() => { firebase.auth().signOut() }} className="btn btn-lg btn-primary logoutBTN" ><FaSignOutAlt />&nbsp;Logout</button>
            </div>
        </div >
    )
}

export default ImagePanel;